import utils from 'ethereumjs-util';

// Hash and add same prefix to the hash that testrpc use.
export default function hashMessage (message) {
  const messageHex = new Buffer(utils.sha3(message).toString('hex'), 'hex');
  const prefix = utils.toBuffer('\u0019Ethereum Signed Message:\n' + messageHex.length.toString());
  return utils.bufferToHex( utils.sha3(Buffer.concat([prefix, messageHex])) );
};
